export const FILTER_DRAWER_WIDTH = 240;
export const FILTER_DRAWER_TRANSITION_DURATION = 150;

/** Left padding of every catalog row, in px — the space before the first column starts. */
export const ROW_LEFT_PADDING = 8;

/** Fixed height of a collapsed catalog row (and each expanded period sub-row), in px. */
export const COLLAPSED_ROW_HEIGHT = 24;
// Extra height every Forward Curves row carries for its persistent
// "View in Spot" link line — feeds the virtualizer's size estimate.
export const VIEW_IN_SPOT_LINK_HEIGHT = 24;
/** Background of an expanded row + its period panel, so they read as one block. */
export const EXPANDED_ROW_BG = '#1A224D';
/**
 * Fixed-width slot reserved before every spot Title so the expand chevron never
 * pushes into the title text and all titles align whether or not they expand.
 */
export const TITLE_CHEVRON_GUTTER = 20;
